import { Link } from "react-router-dom";
import { topics, hotSearch } from "@/mocks/topics";

export default function SiteFooter() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1240px] px-6 py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-eye-2-line text-lg" />
              </span>
              <span className="font-heading text-lg font-black text-foreground-950">
                看料大瓜
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              专注热点事件的现场直击，实时追踪热点实况，汇聚目击者亲历描述与事件时间线。吃瓜第一线，就看这里。
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-mail-line text-primary-600" />
              contact@kanliao-dagua.example.com
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-950">内容栏目</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/live" className="cursor-pointer text-foreground-600 transition-colors hover:text-primary-700">
                  现场直击
                </Link>
              </li>
              <li>
                <Link to="/live?tab=intel" className="cursor-pointer text-foreground-600 transition-colors hover:text-primary-700">
                  瓜田情报
                </Link>
              </li>
              <li>
                <Link to="/about" className="cursor-pointer text-foreground-600 transition-colors hover:text-primary-700">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="cursor-pointer text-foreground-600 transition-colors hover:text-primary-700">
                  内容原则
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-950">热门主题</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {topics.slice(1, 6).map((topic) => (
                <li key={topic.slug}>
                  <Link
                    to={`/live?cat=${topic.slug}`}
                    className="cursor-pointer text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {topic.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-950">正在热议</h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {hotSearch.map((word) => (
                <span
                  key={word}
                  className="rounded-full border border-background-300 bg-background-50 px-3 py-1 text-xs text-foreground-700"
                >
                  {word}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 看料大瓜 · 内容仅供信息交流参考，涉及未核实信息均已明确标注。</p>
          <p className="flex items-center gap-4">
            <span>现场直击</span>
            <span className="h-3 w-px bg-background-300" />
            <span>瓜田情报</span>
            <span className="h-3 w-px bg-background-300" />
            <span>吃瓜第一线</span>
          </p>
        </div>
      </div>
    </footer>
  );
}